/**
 * print.service.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Injectable } from "@angular/core";

import { Subject } from "rxjs/Rx";

/**
 * PrintService provides printing-related UI niceties.
 */
@Injectable()
export class PrintService
{
  /**
   * The print events stream allows other services & components to detect
   * when the user has requested a print view of the page. This doesn't strictly
   * imply that the page is being printed, but indicates that a view has been
   * requested that could be used for printing (such as a print preview, or
   * simply accessing the print options dialog).
   */
  public printEvents : Subject<MediaQueryList> = new Subject<MediaQueryList>();

  constructor ()
  {
    const mediaQueryList : MediaQueryList = window.matchMedia("print");
    mediaQueryList.addListener((mql : MediaQueryList) => {
      if (mql.matches)
      {
        this.printEvents.next(mql);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/common/print.service.ts